import React from "react";
import {
  Box,
  Typography,
  Button,
  Divider,
} from "@mui/material";
import { LogOut } from 'lucide-react';

const ProfileTab = ({ user, handleLogout }) => {
  return (
    <>
      {/* Profile Tab Content */}
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        mb: 6
      }}>
        <Box>
          <Typography 
            variant="h4" 
            sx={{ 
              fontWeight: 600, 
              color: '#fff',
              mb: 1,
              fontSize: '1.75rem',
            }}
          >
            Profile Settings
          </Typography>
          <Typography sx={{ 
            color: '#888', 
            fontSize: '0.875rem',
            maxWidth: '460px',
            lineHeight: 1.6,
          }}>
            Manage your personal information and email preferences.
          </Typography>
        </Box>
      </Box>

      <Box sx={{
        backgroundColor: '#1a1a1a',
        border: '1px solid #2a2a2a',
        borderRadius: '8px',
        p: 4,
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          {/* Name Section */}
          <Box>
            <Typography sx={{ color: '#888', fontSize: '0.75rem', mb: 1 }}>
              NAME
            </Typography>
            <Typography sx={{ color: '#fff', fontSize: '0.875rem' }}>
              {user?.full_name || 'N/A'}
            </Typography>
          </Box>

          {/* Email Section */}
          <Box>
            <Typography sx={{ color: '#888', fontSize: '0.75rem', mb: 1 }}>
              EMAIL
            </Typography>
            <Typography sx={{ color: '#fff', fontSize: '0.875rem' }}>
              {user?.email || 'N/A'}
            </Typography>
          </Box>

          {/* Logout Section */}
          <Divider sx={{ borderColor: '#2a2a2a', my: 2 }} />
          <Box>
            <Typography sx={{ color: '#888', fontSize: '0.75rem', mb: 2 }}>
              ACCOUNT
            </Typography>
            <Button
              onClick={handleLogout}
              startIcon={<LogOut size={16} />}
              sx={{
                border: '1px solid #333',
                color: '#ff4444',
                textTransform: 'none',
                fontSize: '0.875rem',
                px: 2,
                '&:hover': {
                  backgroundColor: '#ff44441a',
                  borderColor: '#ff4444',
                },
              }}
            >
              Log out
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ProfileTab; 